/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

export class Time {
    seconds = 0
	minutes = 0
	hours = 0

	constructor (val) {
		if (val instanceof Time) {
			this.seconds = val.getSeconds();
			this.minutes = val.getMinutes();
			this.hours = val.getHours();
		} else if (typeof val == 'string') {
			this.parseFromString(val);
		} else if (typeof val == 'number') {
			this.parseFromInteger(val);
		} else if (val instanceof Date) { // also DateTime
			this.parseFromDate(val);
		}
	}

	parseFromString (val) {
		val = val.toUpperCase();
		var addHour = 0;
		if (val.search('PM') != -1) {
			addHour = 12;
		}
		val = val.replace('PM', '').replace('AM', '');
		val = val.split(':');

		this.hours = parseInt(val[0], 10) + addHour;
		this.minutes = parseInt(val[1], 10);
    }

	parseFromInteger (val) {
		this.hours = Math.floor(val / 60);
		this.minutes = (val - this.hours * 60);
	}

	parseFromDate (val) {
		this.hours = val.getHours();
		this.minutes = val.getMinutes();
	}

	getHours () {
		return this.hours;
	}

	getMinutes () {
		return this.minutes;
	}

	getSeconds () {
		return this.seconds;
	}

	getInteger () {
		return (this.hours * 60) + this.minutes;
	}

	getFormattedTime (format) {
		var frmt = this._getFormat(format);

		if (frmt == '24hr') { 
			return this._fixZero(this.getHours()) + ':' + this._fixZero(this.getMinutes());
		} else if (format == 'hours' || format == 'hours_24hr' || (format == 'hours_auto' && this._getFormat() == '24hr')) {
			return this._fixZero(this.getHours());
		}

		var pref = 'AM';
		var hours = this.getHours() % 24;
		if (hours >= 12) {
			if (hours > 12) {
				hours = hours - 12;
			}
			pref = 'PM';
		}
		if (hours == 0) {
			hours = 12;
		}

		if (format == 'hours_auto' || frmt == 'hours_ampm') {
			return hours + ' ' + pref;
		}

		return hours + ':' + this._fixZero(this.getMinutes()) + ' ' + pref;
	}

	getMysqlTime () {
		return this._fixZero(this.getHours()) + ':' + this._fixZero(this.getMinutes()) + ':' + this._fixZero(this.getSeconds());
	}

	// getDuration: function () {
	// 	var result = [];
	// 	if (this.hours > 0) {
	// 		result.push(
	// 			this.hours + ' ' + this._getDurationText(this.hours, 'hour')
	// 		);
	// 	}
	// 	if (this.minutes > 0) {
	// 		result.push(
	// 			this.minutes + ' ' + this._getDurationText(this.minutes, 'minute')
	// 		);
	// 	}
	// 	return result.join(', ');
	// },

	// _getDurationText: function (value, type) {
	// 	var value = value.toString();
    //     var text = '';
    //     if (value == '12' || value == '13' || value == '14') {
    //     	text = (type == 'hour' ? 'many_hours_key' : 'minutes');
    //     } else {
    //     	value = value.slice(value.length - 1, value.length);
    //     	if (value == '1') {
    //     		text = (type == 'hour' ? 'hour' : 'minute');
    //    		} else if (value == '2' || value == '3' || value == '4') {
    //     		text = (type == 'hour' ? '2_3_4_hour_key' : '2_3_4_minute_key');
    //    		} else {
    //    			text = (type == 'hour' ? 'many_hours_key' : 'minutes');
    //    		}
    //    	}
    //     return Locale.get(text);
	// },

	_fixZero (val) {
		if (val <= 9) {
			return '0' + val;
		}
		return val;
	}

	_getFormat (format) {
		// if (typeof format === 'undefined') {
		// 	if (jQuery.type(Config) !== 'undefined') {
		// 		format = Config.getTimeFormat();
		// 	} else {
		// 		format = '24hr';
		// 	}
		// }
		return format;
	}
}